module.exports = __webpack_public_path__ + "officialStatic/img/schoolBg1.cb1ea8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/schoolBg1.jpg
// module id = 5w2S
// module chunks = 0